import { render, staticRenderFns } from "./ImagesManager.vue?vue&type=template&id=04525096&scoped=true"
import script from "./ImagesManager.vue?vue&type=script&lang=js"
export * from "./ImagesManager.vue?vue&type=script&lang=js"
import style0 from "./ImagesManager.vue?vue&type=style&index=0&id=04525096&prod&lang=scss&scoped=true"
import style1 from "./ImagesManager.vue?vue&type=style&index=1&id=04525096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04525096",
  null
  
)

export default component.exports